import React from 'react';
import Modal from '../smartAdminUI/Modal';
import ListingImpersonation from './ListingImpersonation/ListingImpersonation';

const ReqImpersonation = () => (
  <Modal
    modalHeader="Impersonation"
    size="lg"
    position="center"
    id="ImpersonationModal"
    type="backdropTransparent"
  >
    <div>
      <ListingImpersonation />
    </div>
  </Modal>
);

export default ReqImpersonation;
